import React, { useState } from 'react';
import { Box, Checkbox, TableCell, TableRow, Tooltip } from '@mui/material';
import { Restore as RestoreIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { ActionPerformed } from '../../../../shared_elements/components';
import LessMoreComp from '../../../../shared_elements/components/CustomLessMoreComp';
import { PermissionWrapper } from '../../../../wrappers';
import { trackActivity } from '../../../../utils/mixpanel';
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AuditPopover from '../../../../shared_elements/components/popover';

const RegionList = ({ uploadedFileData, slug, uploadFileProgressData, viewFileStatus, item, bulk, onEditFn, onView, viewRevisonHistory, onDeleteEolFn, toggleBulkOps, onOpenAttachments }) => {

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Operating Region Esc Listing`, page_type: page_type, })
  }
  return (
    <TableRow>
      <TableCell className="table-actions-list">
        <Box className="table-icon-container">
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "region_escalation", operationType: ['D'] }}>
            <Checkbox style={{ verticalAlign: 'super' }} color="primary" size='small' checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={toggleBulkOps} />
          </PermissionWrapper>
          <AuditPopover item={item}>
            <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
          </AuditPopover>
          <Tooltip title="Revision History"><RestoreIcon className='revision-history' onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} fontSize='small' color='primary' /></Tooltip> 
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "region_escalation", operationType: ['R'] }}>
            <Tooltip title="View"><VisibilityIcon sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('ViewIcon') }} fontSize='small' color='primary' /></Tooltip> 
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "region_escalation", operationType: ['U'] }}>
            <Tooltip title="Edit"><EditIcon sx={{ cursor: 'pointer' }} onClick={() => { onEditFn(); handleItemClicked('EditIcon') }}fontSize='small' color='primary' /></Tooltip> 
          </PermissionWrapper>
          {item?.utilization_created ? null : <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "region_escalation", operationType: ['D'] }}>
            <Tooltip title="Delete"><DeleteIcon sx={{ cursor: 'pointer' }} onClick={() => { onDeleteEolFn(); handleItemClicked('DeleteIcon') }} fontSize='small' color='error' /></Tooltip>
          </PermissionWrapper>}
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "region_escalation", operationType: ['R'] }}>
            {
              item?.attachments?.length > 0 && (
                <Tooltip title="Attached File(s)">
                  <Box className="attachment-container">
                    <AttachFileIcon fontSize="small" color="primary" onClick={() => { onOpenAttachments(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                    <Box className="attachment-count"> ({item.attachments.length}) </Box>
                  </Box>
                </Tooltip>
              )
            }
          </PermissionWrapper>
       { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
        </Box>
      </TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.name || "--"}</TableCell>
      {/* <TableCell>{item.escalation_percentage ?? "--"}</TableCell> */}
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.escalation_percentage !== null && item?.escalation_percentage !== undefined ? item.escalation_percentage : '--'}</TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.remarks?.length > 50 ? "300px" : ''}}><LessMoreComp name={item?.remarks} lessMr='remarks' /></div></TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item.status === false ? "Disabled" : "Enabled" || "--"}</TableCell>
    </TableRow>
  )
}
export default RegionList;